import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { AUTH_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage, useIntl } from "react-intl";

export default function RestoreDeleteStudentWithNoCLassAndNoLicense() {
  const intl = useIntl();
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="RestoreStudentWithNoClassAndNoLicense" />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <p>
            <Input id="student-restore-email-nolicense" placeholder="email" />
          </p>
          <p>
            <Input id="class-name-nolicense" placeholder="class name" />
          </p>
          <p>
            <Input
              id="school-number-nolicense"
              placeholder="school fort nox number"
            />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            onClick={() => {
              var className = document
                .getElementById("class-name-nolicense")
                .value.trim();

              var userEmail = document
                .getElementById("student-restore-email-nolicense")
                .value.trim();

              var customerNumber = document
                .getElementById("school-number-nolicense")
                .value.trim();

              axios
                .post(`${AUTH_BASE_URL}/token/SetLockout`, {
                  email: userEmail,
                  lockout: false,
                })
                .then((res) => {
                  if (res.status === 202) {
                    toast.success(res.data);
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });

              axios
                .post(
                  `${API_BASE_URL}/User/RestoreDeletedStudentWithNoClassAndNoLicense?email=${encodeURIComponent(
                    userEmail
                  )}&className=${className}&schoolFortNoxNumber=${customerNumber}`
                )
                .then((response) => {
                  if (response?.data?.result?.name) {
                    var userName = response.data.result.name;
                    var isDeleted = response.data.result.isDeleted
                      ? intl.formatMessage({ id: "Yes" })
                      : intl.formatMessage({ id: "No" });

                    toast.success(
                      intl.formatMessage(
                        { id: "UserNowHasDeletedStatus" },
                        { userName, status: isDeleted }
                      )
                    );
                  } else {
                    toast.warn(intl.formatMessage({ id: "ServerResponseInvalid" }));
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });
            }}
          >
            <FormattedMessage id="Restore" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
